import { getApiBaseUrl } from "../utils/getApiBaseUrl";

const API_BASE_URL = getApiBaseUrl();

async function parseJson(res) {
  const text = await res.text();
  let body = {};
  try {
    body = text ? JSON.parse(text) : {};
  } catch {
    body = {};
  }
  return { res, body };
}

/**
 * POST /api/treydorex-sale/sync-purchase — read-only chain verify (no entitlements).
 */
export async function syncTrdxWalletPurchase({ txHash, walletAddress, chainId }) {
  const { res, body } = await parseJson(
    await fetch(`${API_BASE_URL.replace(/\/$/, "")}/api/treydorex-sale/sync-purchase`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ txHash, walletAddress, chainId }),
    })
  );

  if (res.status === 202) {
    const err = new Error(body?.message || "Transaction still pending.");
    err.status = 202;
    err.code = "TX_PENDING";
    throw err;
  }

  if (!res.ok) {
    const err = new Error(body?.message || "Dashboard sync failed.");
    err.status = res.status;
    err.code = body?.code;
    throw err;
  }

  return body?.data ?? body;
}
